import { baseComparatorSelector, filterLevelsSelector } from 'advanced-filters/selectors/filter';
import { applyFilter } from 'advanced-filters/store/filter';
import { type AdvancedFilterButtonProps } from 'advanced-filters/types/advancedFilterButton';
import { Button } from 'antd';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

/**
 * @description Button that renders the Footer based on footerConfig
 * Extend this button props to add more customizations
 */
export default function AdvancedFilterButton({
  handleClick,
  CustomComponent,
  action,
  ...props
}: AdvancedFilterButtonProps) {
  const Component = CustomComponent || Button;
  const dispatch = useDispatch();
  const filterLevels = useSelector(filterLevelsSelector);

  const baseComparator = useSelector(baseComparatorSelector);

  const handleButtonClick = useCallback(() => {
    const filter = {
      baseComparator,
      conditions: filterLevels,
    };
    if (handleClick) handleClick(filter);
    if (action === 'submit') {
      dispatch(applyFilter());
    }
  }, [baseComparator, filterLevels, handleClick, action, dispatch]);

  return (
    <Component
      {...props}
      onClick={handleButtonClick}
    />
  );
}
